import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { SpinnerLoaderComponent } from '../components/spinner-loader/spinner-loader.component';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

    private _loading = new BehaviorSubject<boolean>(false);
    public readonly loading$ = this._loading.asObservable();

    constructor(public dialog: MatDialog) { }

    show(message: string, parameter: any | undefined = "") {
        this._loading.next(true);
        this.dialog.open(SpinnerLoaderComponent, {disableClose: true, width: "500px", height: "200px" ,data: { text: message, parameter: parameter }});
    }

    hide() {
        this._loading.next(false);
        this.dialog.closeAll();
    }
}
